export default __webpack_public_path__ + "static/case-studies-header-bf3b430f3a16e08264b30070ec555797.svg";